import { observable, action } from 'mobx';
import agent from '../../api/agent';
import FollowersList from '../../components/artist/followersList';

export default new class artistDetailsStore{

@action likeTheArtwork(id){
    return agent.LikeAndUnlike.likeTheArtwork(id)
} 
@action unLikeTheArtwork(id){
    return agent.LikeAndUnlike.unLikeTheArtwork(id)
} 

}


// WEBPACK FOOTER //
// ./src/stores/artworksStores/likeAndUnlikeStore.js